import React from 'react';
import PropTypes from "prop-types";

import Framework from "@beardeddevops/react.framework";
import {Parts} from "components";

export default class SelectLocation extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		shouldLoad: PropTypes.bool.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
		filter: PropTypes.func.isRequired,
		locations: PropTypes.array.isRequired,
		disabled: PropTypes.bool,
		hideLabel: PropTypes.bool
	};

	render() {

		/** @type {Transactions_Collections_Object|Inventories_Object} object */
		let object = this.props.object;
		let {properties, shouldLoad, onSelectUpdate, locations, filter, disabled, nullable, hideLabel} = this.props;
		return <div className={'form-group'}>
			<div className="row">
				{!hideLabel ? <div className="col-4">
					<span className="input-label">Location</span>
				</div> : null}
				<div className="col-8">
					<Framework.Elements.Select
						shouldLoad={shouldLoad}
						update={onSelectUpdate}
						objects={locations}
						property={properties.location}
						value={object.location}
						binary_id={object.location_binary_id}
						error={object.location_error}
						object={object.locations_related_by_location ? object.locations_related_by_location : object.locations}
						text={'name_display|name'}
						nullable={!!nullable}
						default={nullable?{value: '', label: 'All Locations'}:null}
						defaultFirst={!!nullable}
						filter={filter}
						disabled={!!disabled}
					/>
				</div>
			</div>
		</div>
	}
}

